import "./style.css";
import { render } from "preact";
import { App } from "./app";

const root = window.document.createElement("div");
window.document.body.appendChild(root);
render(<App />, root);
